import React from 'react'

class LogoOperation extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#F37140" d="M407.25 251.244c-.915-10.972-17.707-7.568-27.18-24.864-9.47-17.296-29.42-15.636-37.487-15.972-8.064-.332-74.14-46.076-76.796-53.892-2.66-7.812 5.74-27.596 5.912-37.656.11-6.612-3.16-6.868-15.8-11.108.79-1.068 1.59-2.2 2.39-3.412 22.667-34.272 10.16-56.264 5.023-68.076-5.136-11.808-17.82 1.48-17.82 1.48-18.09 12.22-24.004 33.572-26.2 50.844-10.208-9.556-28.216-26.388-45.01-41.996 0 0-21.55-18.74-33.67 2.796-3.38 6.004-3.31 14.588 10.4 25.504 13.72 10.916 5.98 35.664 5.98 35.664s-30.36-2.752-42.953-18.28C101.46 76.748 92.973 73.5 85.183 71.32c-12.63-3.536-31.635 10.984-21.97 35.76 0 0 9.34 16.136 30.547 18.524 0 0 11.8 6.552 16.65 31.764 0 0 5.36 8.644-3.66 19.388-1.07.848-1.94 2.316-2.65 4.308-14.75-5.48-32.74-11.06-42.27-9.868-17.896 2.24-48.35 7.956-49.572 10.896-4.01 9.664 22.94 31.244 52.24 39.356 18.195 5.04 29.23 1.188 37.25-6.364.27 16.5 1.91 31.04 3.754 48.992-.168-.036-.252-.056-.252-.056s12.52 108.952 16.25 131.244c3.737 22.292 147.873 79.628 167.17 80.664 0 0-30.85-98.94-32.724-124.62-1.316-18.1.912-35.564 3.412-49.8 5.685-2.48 44.17-17.04 53.36-21.32 5.853-2.724 6.34-3.78 18.76-2.92 12.685 5.6 31.757 13.408 37.797 12.664 8.295-1.024 14.367-3.656 15.755-8.756 29.748-1.876 22.996-20.488 22.216-29.932"/>
                    <path fill="#FEFEFE" d="M241.122 197.125l-22.796-18.912-3.332 4.012 22.8 18.916"/>
                    <path fill="#FEFEFE" d="M239.52 179.943l-18.912 22.796-4.012-3.33 18.912-22.8"/>
                </g>
            </svg>

        );
    }
}

export default LogoOperation



// WEBPACK FOOTER //
// ../components/SVG/LogoOperation.jsx